import { FC, useMemo } from "react";
import { get_formated_time } from "../../utils";
import useSatellite from "../../hooks/useSatellite";

interface Props {
    close: (e: any) => void;
    open: boolean;
}

const ScenariInfoContainer: FC<Props> = ({ open, close }) => {

    const { selected_satellite } = useSatellite()
    const orbit_details = useMemo(() => selected_satellite?.value?.orbitParameters, [selected_satellite])

    return (
        <div className={`scenario__orbit__info__container ${open && 'active'}`} onClick={(e)=>{e.stopPropagation()}}>
            <div className="scenario__orbit__info__header">
                <span className="info__title">Orbit Details</span>
                <button className="close_button" onClick={close}>
                    <i className="fe fe-x fs-16 close_icon" />
                </button>
            </div>
            <div className="scenario__orbit__info__details__container">
                <div className="container__left__section">
                    <div className="info__details">
                        <span>{orbit_details?.['epoch'] && `${orbit_details?.['epoch'] && get_formated_time(orbit_details?.['epoch'])}`}</span>
                        <span>Epoch</span>
                    </div>
                    <div className="info__details">
                        <span>{orbit_details?.['altitude']} km</span>
                        <span>Altitude</span>
                    </div>
                    <div className="info__details">
                        <span>{orbit_details?.['eccentricity'] || 0}</span>
                        <span>Eccentricity</span>
                    </div>
                    <div className="info__details">
                        <span>{orbit_details?.['RAAN'] || 0}°</span>
                        <span>RAAN</span>
                    </div>
                </div>
                <div className="container__right__section">

                    <div className="info__details">
                        <span>{orbit_details?.['TA'] || 0}°</span>
                        <span>True Anomaly</span>
                    </div>
                    <div className="info__details">
                        <span>{orbit_details?.['inclination'] || 0}°</span>
                        <span>Inclination</span>
                    </div>
                    <div className="info__details">
                        <span>{orbit_details?.['AP'] || 0}°</span>
                        <span>Argument of Perigee</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScenariInfoContainer